import type { FC } from "react";
import React from "react";
import { Box, Heading } from "@edreamsodigeo/prisma-design-system";

import type { FlightsBannerTitleProps } from "~/components/acquisition/RefundableFlightsBanner/contracts";

const FlightsBannerTitle: FC<FlightsBannerTitleProps> = ({
  title,
  subtitle,
}) => {
  return (
    <Box pt={"3x_big"} px={"big"} pb={"big"}>
      <Heading
        type={"2"}
        color={"neutral.0"}
        textAlign={"center"}
        weight={"medium"}
      >
        {title}
      </Heading>
      <Box pt={"1x_small"} pb={"2x_small"}>
        <Heading type={"6"} color={"neutral.0"} textAlign={"center"}>
          {subtitle}
        </Heading>
      </Box>
    </Box>
  );
};

export default FlightsBannerTitle;
